import type { ComponentTemplate } from "schemas/generated/componentTemplates";

export const knoCommerceWidget: ComponentTemplate = {
  id: "b74bb617-8d8b-44cd-a14b-862a53511ec5",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "KnoCommerce",
  leftBarCategory: { main: "pageIntegrations", subCategory: "other" },
  preview: "integrations/knocommerce.svg",
  transforms: [],
  tags: ["widget"],
  template: {
    id: "$uid",
    type: "knoCommerceWidget",
    props: {},
  },
};
